<!--Normal-->
<div class="d-none d-lg-block">
  <div
    id="gcc-slider-principal"
    class="carousel slide"
    [class.carousel-fade]="fade"
    data-ride="carousel"
  >
    <ol class="carousel-indicators" [class.ballIndicator]="ballIndicator">
      <li
        *ngFor="let img of values; let i = index"
        data-target="#gcc-slider-principal"
        [attr.data-slide-to]="i"
        [class.active]="i == 0"
      ></li>
    </ol>
    <div class="carousel-inner">
      <div
        *ngFor="let img of values; let i = index"
        class="carousel-item"
        [class.active]="i == 0"
      >
        <div *ngIf="img.link; else notLink">
          <a href="{{ img.link }}">
            <img src="{{ API_IMAGENS }}{{ img.image }}" class="d-block w-100" />
          </a>
        </div>
        <ng-template #notLink>
          <img src="{{ API_IMAGENS }}{{ img.image }}" class="d-block w-100" />
        </ng-template>
      </div>
    </div>
  </div>
</div>
<!--Mobile-->
<div class="d-lg-none">
  <div
    id="gcc-slider-principal-mobile"
    class="carousel slide"
    [class.carousel-fade]="fade"
    data-ride="carousel"
  >
    <ol class="carousel-indicators" [class.ballIndicator]="ballIndicator">
      <li
        *ngFor="let img of values; let i = index"
        data-target="#gcc-slider-principal-mobile"
        [attr.data-slide-to]="i"
        [class.active]="i == 0"
      ></li>
    </ol>
    <div class="carousel-inner">
      <div
        *ngFor="let img of values; let i = index"
        class="carousel-item"
        [class.active]="i == 0"
      >
        <div *ngIf="img.link; else notLink">
          <a href="{{ img.link }}">
            <img
              src="{{ API_IMAGENS }}{{ img.imageMobile }}"
              class="d-block w-100"
            />
          </a>
        </div>
        <ng-template #notLink>
          <img
            src="{{ API_IMAGENS }}{{ img.imageMobile }}"
            class="d-block w-100"
          />
        </ng-template>
      </div>
    </div>
  </div>
</div>
